import React from 'react';
import { axios } from '../libs';
import logger from '../utils/logger';

const UpdateLawyersDataButton = () => {
	const handleUpdateClick = async () => {
		try {
			const response = await axios.get('/api/update-lawyers-data');
			logger.log('Full response:', response);
			
			// The response structure is {message: "..."} directly, not nested
			if (response.message) {
				logger.log('SUCCESS - showing green notification');
				window.nSuccess({
					title: 'Success!',
					text: response.message,
					icon: 'fa-check-square'
				});
			} else {
				logger.log('ERROR - no message found');
				window.nError({
					title: 'Error!',
					text: 'Failed to update lawyers data',
					icon: 'fa-exclamation-triangle'
				});
			}
		} catch (error) {
			logger.error('EXCEPTION - Error updating lawyers data:', error);
			logger.error('Error response:', error.response);
			window.nError({
				title: 'Error!',
				text: 'An error occurred while updating lawyers data.',
				icon: 'fa-exclamation-triangle'
			});
		}
	};
	return (
		<button onClick={handleUpdateClick}>Update Matchmaking Data</button>
	);
};

export default UpdateLawyersDataButton;
